//LL: 26.06.19: add 'number' instead of 'i' and 'r', combine them using 'r' functionality

import * as React from 'react';
import * as _ from 'underscore';
import * as $ from 'jquery';

import NumberField from './NumberField';
import StringField from './StringField';
import { ColorBoxField } from './ColorBoxField';

import { DiscreteIntervals_Color, dataTypes } from './DiscreteIntervals';

import * as appTheme from '../ts/appTheme';

import * as Utils from '../ts/Utilities'; // class ColorHexWrapper is copied here

var startColorDefault = '#ffff00'; // yellow   or "#ffff80"
var endColorDefault = '#b70000'; // cranberry
var nullColorDefault = null; //LL: 26.11.19: for not-discrete, Null values
var mappingValues = ['linear', 'logarithmic', 'discrete']; //LL: 17.05.19: add 'discrete'
var mappingIndexDefault = 0;
//LL: 26.06.19: add 'number', instead of i, r
//LL: 17.05.19   and see Utilities.explainAttributeType(attrType)
//LL: without 's', without 'b':
//var dataTypes = [ 'i', 'r', 'date', 'datetime', 'time'];
//LL: 15.11.19: move to DiscreteIntervals:   //LL: 18.11.19: add 'string'
//var dataTypes = [ 'number', 'date', 'datetime', 'time', 'string'];

var dataTypesIndexDefault = 0;

class ColorMappingForNumericFieldRow extends React.Component<any, any> {
    //LL: 13.01.25 
    private references: {
        mapping?: HTMLElement; // HTMLDivElement;
        dataType?: HTMLElement; // HTMLDivElement;
        //scaleAuto?: HTMLElement; // HTMLDivElement;
        scaleMethod?: HTMLElement; // HTMLDivElement;
    } = {};

    constructor(props) {
        super(props);

        // themeObj 
        // allowColorFunctionsFlag={ ColorMappingForNumericField.allowColorFunctionsFlag }
    }

    normalize(value) {
        if (value.name == null) {
            delete value.mapping;

            delete value.startColor;
            delete value.endColor;
            delete value.nullColor;

            delete value.scaleAuto;
            delete value.scaleMin;
            delete value.scaleMax;

            delete value.colorIntervals;
            delete value.dataType;

            return;
        }

        //LL: wrong
        //if (value.value != null) {
        //    value.value = $.trim(value.value);
        //}

        //LL: or create and use ConfigurationConstants.xxx.mappingValues
        let find = _.find(mappingValues, function (val) {
            return val === value.mapping;
        });
        if (find == null) {
            delete value.mapping;
        }

        //LL: 26.06.19: add 'number', instead of i, r
        if (value.dataType === 'i' || value.dataType === 'r') {
            value.dataType == 'number';
        }
    }

    processNameChange = (val) => {
        let obj = _.clone(this.props.value || {});
        obj.name = val;
        this.handleValueChange(obj);
    }
    processNameClick = (e) => {
        let obj = _.clone(this.props.value || {});
        obj.name = '';
        this.handleValueChange(obj);
    }

    processMappingChange = (e) => {
        let elem: any = this.references.mapping; //LL: 13.01.25
        let val = elem.value;
        let obj = _.clone(this.props.value || {});
        obj.mapping = val;
        this.handleValueChange(obj);
    }

    //LL: 17.05.19:  for 'discrete'
    processDataTypeChange = (e) => {
        let elem: any = this.references.dataType; //LL: 13.01.25
        let val = elem.value;
        let obj = _.clone(this.props.value || {});

        //LL: 15.11.19: must clear Intervals when DataType is changed
        let defined =
            obj.colorIntervals != null && obj.colorIntervals.values != null && obj.colorIntervals.values.length > 0;
        if (defined) {
            let result = confirm('When DataType is changed, Intervals will be cleared.'); //  OK, Cancel
            if (result === false) {
                return;
            }
        }

        //  clear:  nullMapped remains
        //  or obj.colorIntervals = null;
        if (defined) {
            delete obj.colorIntervals.values;
            delete obj.colorIntervals.labels;
        }

        obj.dataType = val;
        this.handleValueChange(obj);
    }

    processStartColorChange = (val) => {
        let obj = _.clone(this.props.value || {});
        obj.startColor = val;
        this.handleValueChange(obj);
    }

    processEndColorChange = (val) => {
        let obj = _.clone(this.props.value || {});
        obj.endColor = val;
        this.handleValueChange(obj);
    }

    //LL: 26.11.19: for not-discrete, Null values
    processNullColorChange = (val) => {
        let obj = _.clone(this.props.value || {});
        obj.nullColor = val;
        this.handleValueChange(obj);
    }

    //LL: 13.01.25 not used
    // processScaleChange(e) {
    //     let obj = _.clone(this.props.value || {});
    //     //let elem: any = ReactDOM.findDOMNode(this.refs['scaleAuto']);
    //     let elem: any = this.references.scaleAuto; //LL: 13.01.25
    //     let val = elem.checked; //LL: not value
    //     obj.scaleAuto = val;
    //     this.handleValueChange(obj);
    // }

    processScaleMinChange = (val) => {
        let obj = _.clone(this.props.value || {});
        obj.scaleMin = val;
        this.handleValueChange(obj);
    }

    processScaleMaxChange = (val) => {
        let obj = _.clone(this.props.value || {});
        obj.scaleMax = val;
        this.handleValueChange(obj);
    }

    processScaleMethodChange = (e) => {
        let elem: any = this.references.scaleMethod; //LL: 13.01.25
        let val = elem.value;

        let obj = _.clone(this.props.value || {});
        obj.scaleMethod = val;

        //LL:  set values of old functionality:
        switch (val) {
            case 'automatic':
                obj.scaleAuto = true;
                break;
            case 'defineRange':
                obj.scaleAuto = false;
                break;
        }

        this.handleValueChange(obj);
    }

    handleValueChange(value) {
        this.normalize(value);

        //LL: 08.04.19: changed => not inherited
        delete value.inherited;

        if (typeof this.props.onChange === 'function') {
            this.props.onChange(value, this.props.i);
        }
    }

    handleRemove = () => {
        if (typeof this.props.onRemove === 'function') {
            this.props.onRemove(this.props.i);
        }
    }

    getRemoveButton(value) {
        if (value.name == null) {
            return;
        }

        //LL: 08.04.19:  "disabled" not used ?
        if (value.disabled === true) {
            return;
        }

        //LL: 08.04.19:
        if (value.inherited === true) {
            return <span className="glyphicon glyphicon-arrow-down"></span>;
        }

        return <span className="glyphicon glyphicon-remove" onClick={this.handleRemove}></span>;
    }

    getNameTitle(value) {
        return value.name || '';
    }

    getName(value) {
        let displayVal = value.name || '';

        //  was    add Color Mapping  or add Color Scale
        if (value.name == null) {
            let displayValEmpty = (
                <button type="button" className="btn btn-default btn-sm" onClick={this.processNameClick}>
                    {'Add'}
                </button>
            );
            return (
                <div className="entity-select">
                    <div className="content">
                        <span className="value">{displayValEmpty}</span>
                    </div>
                </div>
            );
        }

        let readOnly = value.disabled === true;
        //LL: style="cursor:default" for readonly in StringField

        return (
            <StringField
                onChange={this.processNameChange}
                value={displayVal}
                readOnly={readOnly}
                allowNull={false}
                applyOnEnter={true}
                changeOnBlurOnly={true}
            />
        );
    }

    isDiscreteMapping(value) {
        return value.mapping === 'discrete';
    }

    getMapping(value) {
        if (value.name == null) {
            return;
        }

        let displayVal = value.mapping || mappingValues[mappingIndexDefault];

        let readOnly = value.disabled === true;

        let style1: any = {};
        if (value.disabled === true) {
            style1.cursor = 'default';
        }

        let options = _.map(mappingValues, function (val) {
            return (
                <option key={val} value={val}>
                    {val}
                </option>
            );
        });

        return (
            <select
                ref={(input) => {
                    this.references.mapping = input;
                }} //LL: 13.01.25
                className="form-control"
                style={style1}
                onChange={this.processMappingChange}
                value={displayVal}
                disabled={readOnly}
            >
                {options}
            </select>
        );
    }

    //LL: 17.05.19:  for 'discrete'
    getDataType(value) {
        if (value.name == null) {
            return;
        }

        let displayVal = value.dataType || dataTypes[dataTypesIndexDefault];

        let readOnly = value.disabled === true;

        let style1: any = {};
        if (value.disabled === true) {
            style1.cursor = 'default';
        }

        //LL: 17.05.19   and see Utilities.explainAttributeType(attrType)
        let options = _.map(dataTypes, function (val) {
            return (
                <option key={val} value={val}>
                    {Utils.explainAttributeType(val)}
                </option>
            );
        });

        return (
            <select
                ref={(input) => {
                    this.references.dataType = input;
                }} //LL: 13.01.25
                className="form-control"
                style={style1}
                onChange={this.processDataTypeChange}
                value={displayVal}
                disabled={readOnly}
            >
                {options}
            </select>
        );
    }

    getStartColor(value) {
        if (value.name == null) {
            return;
        }

        let displayVal = value.startColor || startColorDefault;

        //  https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input/color
        //LL: readonly is not interesting

        let readOnly = value.disabled === true;
        let disabled = value.disabled === true;
        let onChange_ColorBox = value.disabled === true ? null : this.processStartColorChange;

        return (
            <ColorBoxField
                value={displayVal}
                hideTransparency={true}
                showText={false}
                readOnly={readOnly}
                disabled={disabled}
                themeObj={this.props.themeObj}
                onChange={onChange_ColorBox}
                glob={this.props.glob}
            />
        );
    }

    getEndColor(value) {
        if (value.name == null) {
            return;
        }

        let displayVal = value.endColor || endColorDefault;

        let readOnly = value.disabled === true;
        let disabled = value.disabled === true;
        let onChange_ColorBox = value.disabled === true ? null : this.processEndColorChange;

        return (
            <ColorBoxField
                value={displayVal}
                hideTransparency={true}
                showText={false}
                readOnly={readOnly}
                disabled={disabled}
                themeObj={this.props.themeObj}
                onChange={onChange_ColorBox}
                glob={this.props.glob}
            />
        );
    }

    //LL: 26.11.19: for not-discrete, Null values
    getNullColor(value) {
        if (value.name == null) {
            return;
        }

        let displayVal = value.nullColor || nullColorDefault;

        let readOnly = value.disabled === true;
        let disabled = value.disabled === true;
        let onChange_ColorBox = value.disabled === true ? null : this.processNullColorChange;

        return (
            <ColorBoxField
                value={displayVal}
                hideTransparency={true}
                showText={false}
                readOnly={readOnly}
                disabled={disabled}
                themeObj={this.props.themeObj}
                onChange={onChange_ColorBox}
                glob={this.props.glob}
            />
        );
    }

    getColorSample(value) {
        if (value.name == null) {
            return;
        }

        let startColor = value.startColor || startColorDefault;
        let endColor = value.endColor || endColorDefault;

        let style1 = {
            paddingTop: 0,
            paddingBottom: 0
        };

        let style2 = {
            marginTop: 4,
            height: 15,
            background: 'linear-gradient(to right, ' + startColor + ', ' + endColor + ')'
        };

        return (
            <div className="form-control" style={style1}>
                <div className="form-control" style={style2} />
            </div>
        );
    }

    process_DiscreteIntervals_Color_Change = (val) => {
        //   val:  { labels:[], values:[] }
        let obj = _.clone(this.props.value || {});
        obj.colorIntervals = val;
        this.handleValueChange(obj);
    }

    getColorIntervals(value) {
        if (value.name == null) {
            return;
        }

        let dataType = value.dataType || dataTypes[dataTypesIndexDefault];

        let displayVal_colorIntervals = value.colorIntervals; //  may be null

        return (
            <DiscreteIntervals_Color
                value={displayVal_colorIntervals}
                type={dataType}
                onChange={this.process_DiscreteIntervals_Color_Change}
                themeObj={this.props.themeObj}
                allowColorFunctionsFlag={this.props.allowColorFunctionsFlag}
                glob={this.props.glob}
            />
        );
    }

    getScale(value) {
        if (value.name == null) {
            return;
        }

        //LL: old code used in "redesign":
        let scaleAuto = value.scaleAuto;
        if (scaleAuto == null) {
            scaleAuto = true;
        }

        //LL: ======= old code used in "redesign":    for Min/Max
        let minText: any = 'min: ';
        let maxText: any = 'max: ';

        let readOnly = value.disabled === true;

        let displayValMin = value.scaleMin || 0;
        let displayValMax = value.scaleMax || 0;

        //LL: Oh, no readOnly in NumberField ??? !!!
        let onChangeMin = value.disabled === true ? null : this.processScaleMinChange;
        let onChangeMax = value.disabled === true ? null : this.processScaleMaxChange;

        let minField, maxField;
        if (!scaleAuto) {
            if (readOnly) {
                minField = <StringField value={displayValMin} readOnly={true} />;
                maxField = <StringField value={displayValMax} readOnly={true} />;
            } else {
                minField = (
                    <NumberField
                        value={displayValMin}
                        allowNull={true}
                        applyOnEnter={true}
                        integer={false}
                        onChange={onChangeMin}
                    />
                );
                maxField = (
                    <NumberField
                        value={displayValMax}
                        allowNull={true}
                        applyOnEnter={true}
                        integer={false}
                        onChange={onChangeMax}
                    />
                );
            }
        }

        //LL: --------- FIN old code used also in "redesign"

        //LL: 20.06.19: (as in ChartCustomStyles) redesign with flex, without radio-buttons:    See also changes in sass
        //let redesign = false;  //  old
        let redesign = true; // my flag
        if (redesign) {
            let list = [
                { value: 'automatic', label: 'automatic' },
                { value: 'defineRange', label: 'define range' }
            ];
            let options = _.map(list, function (val) {
                return (
                    <option key={val.value} value={val.value}>
                        {val.label}
                    </option>
                );
            });

            //LL: or maybe base on old obj.colorDefault, obj.colorPalette - if not set:
            let scaleMethodVal = value.scaleMethod;
            if (scaleMethodVal == null) {
                scaleMethodVal = scaleAuto ? 'automatic' : 'defineRange';
            }

            let onChangeMethod = value.disabled === true ? null : this.processScaleMethodChange;

            let selectElem = (
                <select
                    ref={(input) => {
                        this.references.scaleMethod = input;
                    }} //LL: 13.01.25
                    className="form-control scale-container-scaleMethod"
                    onChange={onChangeMethod}
                    value={scaleMethodVal}
                >
                    {options}
                </select>
            );

            let rightPaneContent: any;
            switch (scaleMethodVal) {
                case 'automatic':
                    rightPaneContent = 'scale by actual values'; // "actual min/max values";
                    break;
                case 'defineRange':
                    rightPaneContent = (
                        <React.Fragment>
                            {minText}
                            <div className="scale-container-pane-value cell-scaleDivMarginRight">{minField}</div>
                            {maxText}
                            <div className="scale-container-pane-value">{maxField}</div>
                        </React.Fragment>
                    );

                    break;
            }

            //LL:  is flex inside element and flex container itself:
            let rightPane = <div className="scale-container-pane">{rightPaneContent}</div>;

            let style1: any = {};
            if (value.disabled === true) {
                style1.backgroundColor = '#eeeeee';
                style1.cursor = 'default';
            }

            return (
                <div className="form-control scale-container" style={style1}>
                    {selectElem}
                    {rightPane}
                </div>
            );
        }
    }

    render() {
        let value = this.props.value || {};

        let style1: any = {};
        if (value.disabled === true) {
            style1.backgroundColor = '#eeeeee';
            style1.cursor = 'default';
        }

        //LL: 17.05.19: this.isDiscreteMapping(value)
        //   For 'discrete':  new columns  "Intervals",  "Data Type"
        //           not shown  Start, End, Sample, Scale

        let tdStartColorElem;
        let tdEndColorElem;
        let tdNullColorElem; //LL: 26.11.19: for not-discrete, Null values
        let tdColorSampleElem;
        let tdScaleElem;
        if (!this.isDiscreteMapping(value)) {
            tdStartColorElem = this.getStartColor(value);
            tdEndColorElem = this.getEndColor(value);
            tdNullColorElem = this.getNullColor(value);
            tdColorSampleElem = this.getColorSample(value);
            tdScaleElem = this.getScale(value);
        }

        let tdDataTypeElem;
        let tdColorIntervalsElem; //  either it or tdScaleElem
        if (this.isDiscreteMapping(value)) {
            tdDataTypeElem = this.getDataType(value);
            tdColorIntervalsElem = this.getColorIntervals(value);
        }

        return (
            <tr style={style1}>
                <td className="cell-remove">{this.getRemoveButton(value)}</td>
                <td className="cell-name" title={this.getNameTitle(value)}>
                    {this.getName(value)}
                </td>
                <td className="cell-mapping">{this.getMapping(value)}</td>
                <td className="cell-startColor">{tdStartColorElem}</td>
                <td className="cell-startColor">{tdEndColorElem}</td>
                <td className="cell-colorSample">{tdColorSampleElem}</td>
                <td className="cell-startColor">{tdNullColorElem}</td>
                <td className="cell-dataType">{tdDataTypeElem}</td>
                <td className="cell-scale">
                    {tdScaleElem}
                    {tdColorIntervalsElem}
                </td>
            </tr>
        );
    }
}

function getState() {
    return {};
}

export default class ColorMappingForNumericField extends React.Component<any, any> {
    //LL: 05.11.19:  TRY
    private allowColorFunctionsFlag = false; //LL: my flag     old
    //private allowColorFunctionsFlag = true;  //LL: my flag   new

    //LL: 24.05.19:
    public static reduceByType(ColorMappingArr, aType) {
        if (ColorMappingArr == null) {
            return null;
        }
        let arr = [];
        _.each(ColorMappingArr, function (cm: any, index) {
            if (cm.mapping !== 'discrete') {
                //arr.push(cm);
                //LL: now only for numeric:
                if (aType === 'i' || aType === 'r') {
                    arr.push(cm);
                }
            } else {
                let toAdd = true;
                switch (aType) {
                    case 'i':
                    case 'r':
                        toAdd = cm.dataType === 'i' || cm.dataType === 'r' || cm.dataType === 'number';
                        break;
                    case 'date':
                    case 'datetime':
                        toAdd = cm.dataType === 'date' || cm.dataType === 'datetime';
                        break;
                    case 'time':
                        toAdd = cm.dataType === 'time';
                        break;
                }
                if (toAdd) {
                    arr.push(cm);
                }
            }
        });

        return arr;
    }

    constructor(props) {
        super(props);

        //LL: from ThemeField.tsx:
        //    in class EditComponentDepsWrapper:  see ownValue?;  parentValue?;
        //      in render:
        //        EditComponentOptions.optionThemeOwnAndParent = {
        //            ownValue: this.props.ownValue,
        //            parentValue: this.props.parentValue
        //        }
        //        and
        //            <this.props.EditComponent
        //                key="parameter-filed-edit"
        //                value={ this.props.value }
        //                param={ this.props.param }
        //                options={ EditComponentOptions }
        //
        //                onChange={ this.props.onChange }
        //
        //                glob={ this.props.glob }
        //            />

        //  so look:
        //  this.props.options = EditComponentOptions,
        //                optionThemeOwnAndParent:  ownValue: undefined   parentValue:
        //  this.props.value:   array of cmnf
        //  this.props.param:   CMFN obj as Field

        //LL: 24.04.19:
        //LL: "optionThemeOwnAndParent" is from ThemeField.tsx  EditComponentDepsWrapper.render:
        if (this.props.options != null) {
            let optionThemeOwnAndParent = this.props.options.optionThemeOwnAndParent;
            //console.log("ColorMappingForNumericField constructor optionThemeOwnAndParent = " + optionThemeOwnAndParent);
            //if (optionThemeOwnAndParent != null) {
            //    console.log("ColorMappingForNumericField constructor ownValue = " + optionThemeOwnAndParent.ownValue);
            //    console.log("ColorMappingForNumericField constructor parentValue = " + optionThemeOwnAndParent.parentValue);
            //}
        }

        //this.reorderStart = this.reorderStart.bind(this);
        //this.reorderStop = this.reorderStop.bind(this);
    }

    //LL: 18.02.20:  NOTE about Reorder vs Sorting: =============================
    //   Items can either reordered by user's DragDrop or sorted by some internal algorithm (alphabetically here)
    //   Previous solution was Reorder, but it is not convenient and mixing own/parent items is bad
    //   So, now it will be Sorting, see function getSortedValuesByName
    //============================================================================

    //LL: 18.02.20:
    //    Commented (don't remove)  startIndex, reorderStart, reorderStop, processReorder, "sortable"

    //private startIndex;
    //
    //reorderStart(e, ui) {
    //    this.startIndex = $(ui.item).index();
    //}
    //
    //reorderStop (e, ui) {
    //    if (this.startIndex == null) { return; }
    //
    //    let startIndex = this.startIndex;
    //    let stopIndex = $(ui.item).index();
    //
    //    this.startIndex = null;
    //
    //    //LL: see: https://gist.github.com/avakhov/7b9d2b1a354e59dbfa63
    //    //   Вызываем cancel, чтобы элементы местами поменял React.js
    //    //   $(me.getDOMNode()).sortable("cancel");
    //    //const tableBody = this.references.tableBody;
    //    let tableBody = ReactDOM.findDOMNode(this.refs['tableBody']);
    //    $(tableBody).sortable("cancel");
    //
    //    this.processReorder(startIndex, stopIndex);
    //}

    componentDidMount() {
        ////let tableBody = this.refs.tableBody;
        //let tableBody = ReactDOM.findDOMNode(this.refs['tableBody']);
        //
        //if (typeof $(tableBody).sortable === 'function') {
        //    $(tableBody).sortable({
        //        axis: 'y',
        //        forceHelperSize: true,
        //        items: 'tr:not(.empty)',
        //        opacity: 0.8,
        //        handle: '.cell-name',
        //        cursor: 'grabbing',
        //        start: this.reorderStart,
        //        stop: this.reorderStop
        //    });
        //}
    }

    componentWillUnmount() {
        ////let tableBody = this.refs.tableBody;
        //let tableBody = ReactDOM.findDOMNode(this.refs['tableBody']);
        //$(tableBody).sortable('destroy');
    }

    _onChange() {
        this.setState(getState.call(this));
    }

    //processReorder(start, stop) {
    //    if (start === stop) { return; }
    //
    //    let value = this.props.value.slice(0);
    //
    //    let item = value.splice(start, 1);
    //    value.splice(stop, 0, item[0]);
    //
    //    this.handleValueChange(value);
    //}

    handleValueChange(value) {
        if (typeof this.props.onChange === 'function') {
            this.props.onChange(value);
        }
    }

    addRow = (obj: any) => {    
        let arr = this.props.value.slice(0);

        obj.mapping = mappingValues[mappingIndexDefault];

        obj.startColor = startColorDefault;
        obj.endColor = endColorDefault;
        obj.nullColor = nullColorDefault; //LL: 26.11.19: for not-discrete, Null values

        obj.scaleAuto = true;
        obj.scaleMin = 0;
        obj.scaleMax = 0;

        obj.colorIntervals = null; // or {} ?
        obj.dataType = dataTypes[dataTypesIndexDefault];

        obj.disabled = false;

        arr.push(obj);
        this.handleValueChange(arr);
    }

    changeRow = (obj: any, i) => {
        let arr = this.props.value.slice(0);
        let prev = arr.splice(i, 1, obj)[0];
        this.handleValueChange(arr);
    }

    removeRow = (i) => {
        let arr = this.props.value.slice(0);
        arr.splice(i, 1);
        this.handleValueChange(arr);
    }

    render() {
        let self = this;

        //LL: "optionThemeOwnAndParent" is from ThemeField.tsx  EditComponentDepsWrapper.render:

        let objThemeOwnAndParent = appTheme.getThemeOwnAndParentvalues(this.props);
        let ownValues = objThemeOwnAndParent.ownValues;
        let parentValues = objThemeOwnAndParent.parentValues;

        let aaa = appTheme.getSortedValuesByName(this.props.value); //LL: 17.02.20 return { arr: arr, indices: indices };

        //LL: 26.06.19: add 'number', instead of i, r
        let rows = _.map(
            aaa.arr,
            function (obj: any, i) {
                let obj2: any = appTheme.setProperInheritedFlag(
                    obj,
                    ownValues,
                    parentValues,
                    'ColorMappingForNumericField'
                );
                //LL: may be null, if just removed
                if (obj2 == null) {
                    return null;
                }

                //LL: 26.06.19: add 'number', instead of i, r
                if (obj2.dataType === 'i' || obj2.dataType === 'r') {
                    if (obj2.dataType === 'i' && obj2.colorIntervals != null) {
                        obj2.colorIntervals.precision = 0;
                    }
                    obj2.dataType = 'number';
                }

                let j = aaa.indices[i]; //LL: 17.02.20

                return (
                    <ColorMappingForNumericFieldRow
                        key={i + '-' + obj2.name}
                        i={j}
                        value={obj2}
                        themeObj={self.props.themeObj}
                        allowColorFunctionsFlag={self.allowColorFunctionsFlag}
                        onChange={self.changeRow}
                        onRemove={self.removeRow}
                        glob={self.props.glob}
                    />
                );
            }
        );

        let showTableHeaders = rows.length > 0;

        let style1 = { marginBottom: 5 }; // class "table" has margin-bottom:20px

        let style2 = {
            paddingBottom: 15
        };

        //LL: 17.05.19: this.isDiscreteMapping(value)
        //   For 'discrete':  new columns  "Intervals",  "Data Type"
        //           not shown  Start, End, Sample, Scale

        return (
            <div className={'colormappingfornumeric-field-inTheme'}>
                <div className={'div-container'} style={style2}>
                    <div className="colormappingfornumeric-field-inTheme-common"></div>
                    <table className={'table' + (this.props.border === true ? ' table-bordered' : '')} style={style1}>
                        {showTableHeaders === true ? (
                            <thead>
                                <tr>
                                    <th className="cell-remove"></th>
                                    <th className="cell-name">Name</th>
                                    <th className="cell-mapping">Mapping</th>
                                    <th className="cell-startColor">Start Color</th>
                                    <th className="cell-startColor">End Color</th>
                                    <th className="cell-colorSample">Color Scale</th>
                                    <th className="cell-startColor" title="for Null values">
                                        Null Color
                                    </th>
                                    <th className="cell-dataType">Data Type for Discrete</th>
                                    <th className="cell-scale">Value Scale or Discrete Color Intervals</th>
                                </tr>
                            </thead>
                        ) : null}
                        <tbody 
                            // ref={(input) => {
                            //     this.references.tableBody = input;
                            // }} //LL: 13.01.25
                        >
                            {rows}
                            <ColorMappingForNumericFieldRow
                                themeObj={this.props.themeObj}
                                allowColorFunctionsFlag={this.allowColorFunctionsFlag}
                                onChange={this.addRow}
                                glob={this.props.glob}
                            />
                        </tbody>
                    </table>
                </div>
            </div>
        );
    }
}
